<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="RequestsFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#posRequestsFilter">
                    <div class="card-body">
                        <form id="posRequestsFilter" @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="4" md="4" lg="4">
                                        <kt-form-group>
                                            <kt-form-label for="customer_code">
                                                {{ $t('pos.customer_code') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="customer_code"
                                                    dir="ltr"
                                                    name="customer_code"
                                                    id="customer_code"
                                                    v-model="query.customer_code"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4" lg="4">
                                        <kt-form-group>
                                            <kt-form-label for="shop_name">
                                                {{ $t('pos.shop_name') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="shop_name"
                                                    dir="rtl"
                                                    name="shop_name"
                                                    id="shop_name"
                                                    v-model="query.shop_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4" lg="4">
                                        <kt-form-group>
                                            <kt-form-label for="terminal_number">
                                                {{ $t('label.terminal_number') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="terminal_number"
                                                    dir="ltr"
                                                    name="terminal_number"
                                                    id="terminal_number"
                                                        v-model="query.terminal_number"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                    <kt-col xs="12" sm="4" md="4" lg="4">
                                        <kt-form-group>
                                            <kt-form-label for="followup_code">
                                                {{ $t('pos.followup_code') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="followup_code"
                                                    dir="ltr"
                                                    name="followup_code"
                                                    id="followup_code"
                                                    v-model="query.followup_code"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4" lg="4">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name="from_date"
                                                    v-model="query.from_date"
                                                    type="datetime"/>
                                        </kt-form-group>
                                    </kt-col>

                                    <kt-col xs="12" sm="4" md="4" lg="4">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name="to_date"
                                                    v-model="query.to_date"
                                                    type="datetime"
                                            />
                                        </kt-form-group>
                                    </kt-col>

                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="6" lg="6">
                                        <input type="submit" class="btn btn-success btn-wide"
                                               :value="$t('label.filter')"></kt-col>

                                </kt-row>
                            </kt-form-section>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
    import {i18n} from "@/plugins/i18n";

    export default {
        props: {
            action: {
                default: function (e, query) {
                },
                required: true,
            },
            query: {
                type: Object,
                required: true,
            },
        },
        data() {
            return{
                customerTypes:[
                    {
                        value: '1327',
                        title:i18n.t('label.real'),
                    },
                    {
                        value: '1328',
                        title:i18n.t('label.legal'),
                    },
                ],
            }
    },
        methods: {
            clearFromDate() {
                if (this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if (this.query.to_date) {
                    this.query.to_date = null
                }
            },
        },
        mounted() {
        }

    }
</script>

<style>

</style>